// @core/api/endpoints/subscription/get_discount.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DiscountResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Get discount details
 * Retrieves complete discount configuration including redemption count, validity period, and applicable plans.
 */
export async function GetDiscount(
  discount_id: string,
  options?: RequestOptions
): Promise<DiscountResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/discounts/:discount_id`;
  requestPath = requestPath.replace(':discount_id', encodeURIComponent(discount_id));
  const requestOptions = options;
  return client.get<DiscountResponse>(requestPath, { ...requestOptions });
}
